<template>
    <div>
        <release-record/>
    </div>
</template>
<script>
import ReleaseRecord from './components/releaseRecord'
export default {
    name : 'system-versionPage',
    components: {
       ReleaseRecord, 
    }
    
    
}
</script>